// API client for Inventory Performance Metrics.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/inventory-performance`;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

const call = async (url, opts = {}) => {
  const res = await fetch(url, opts);
  const body = await res.json();
  if (!res.ok || body.error) {
    throw new Error(body.error || body.message || `Request failed (${res.status})`);
  }
  return body;
};

export const getOverview = (token, { refresh = false } = {}) =>
  call(`${BASE}/overview${refresh ? '?refresh=1' : ''}`, { headers: authHeaders(token) });
export const getExcess = (token) => call(`${BASE}/excess`, { headers: authHeaders(token) });
export const getStranded = (token) => call(`${BASE}/stranded`, { headers: authHeaders(token) });
export const getAging = (token) => call(`${BASE}/aging`, { headers: authHeaders(token) });
export const getSellThrough = (token) => call(`${BASE}/sell-through`, { headers: authHeaders(token) });
export const getIpi = (token) => call(`${BASE}/ipi`, { headers: authHeaders(token) });
export const getStorage = (token) => call(`${BASE}/storage`, { headers: authHeaders(token) });
